const dataRoadMap = [

    {
        id: 1,
        time: 'Phase 1: Discovery Call',
        title: 'Lock In the Vision',
        desc: 'We hop on a quick call to get your vibe, goals, and guest list expectations. No generic templates — this is built for you.',
        class: ''
    },
    {
        id: 2,
        time: 'Phase 2: Strategy Mode',
        title: 'Plan the Takeover',
        desc: 'We map out the concept, find the perfect venue, lock in DJs, and design custom promo content that hits.',
        class: 'right'
    },
    {
        id: 3,
        time: 'Phase 3: Go Live',
        title: 'Drop the Promo',
        desc: 'We launch the campaign on IG, TikTok, and private RSVP channels. Hype builds, lists fill, buzz spreads.',
        class: ''
    },
    {
        id: 4,
        time: 'Phase 4: Show Time',
        title: 'Execute the Experience',
        desc: 'We handle the door, crowd flow, and vibe management. You show up, pop bottles, and own the night.',
        class: 'right'
    },
    {
        id: 5,
        time: 'Phase 5: Post-Game',
        title: 'Content Recap & Loyalty Build',
        desc: 'We deliver recap content, follow up with attendees, and help you turn one event into a movement.',
        class: ''
    },

]

export default dataRoadMap;